import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SubjectDataResponse } from '@brighthub/uisession';
import { ApiService, GenericResponseResult } from '@brighthub/api';

@Injectable({
  providedIn: 'root'
})
export class ClientSearchService {

  private _api = inject(ApiService);

  searchByGuid(guid: string): Observable<SubjectDataResponse & GenericResponseResult> {
    return this._api.get<SubjectDataResponse>('api-mobile', `/clients/${guid}`);
  }
}
